export default function formatDateToThaiPattern(dateString) {
    const dateParts = dateString.split("/");
    const year = parseInt(dateParts[0]) + 543;
    const month = parseInt(dateParts[1]);
    const day = dateParts[2];

    // Thai month names
    const thaiMonths = [
        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
        'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
        'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];

    return `${day} ${thaiMonths[month - 1]} ${year}`;
}

//   const originalDate = "2024-10-04";
//   const thaiPatternDate = formatDateToThaiPattern(originalDate);
//   console.log(thaiPatternDate); // Output: "4 ตุลาคม 2024"